// Barre livraison offerte / produit offert du panier — snippets/cart-rewards.liquid
if (!customElements.get('cart-rewards')) {
  let lastGiftAttempt = '';

  const postCart = (url, body) => fetch(url, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body)
  }).then((response) => response.json());

  customElements.define('cart-rewards', class CartRewards extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.cart-rewards__track');
      this.querySelectorAll('.cart-rewards__arrow').forEach((arrow) => {
        arrow.addEventListener('click', () => this.scrollTrack(Number(arrow.dataset.direction)));
      });
      this.querySelectorAll('.cart-rewards__product-add').forEach((button) => {
        button.addEventListener('click', () => this.addProduct(button));
      });
      this.syncGift();
    }

    syncGift() {
      const action = this.dataset.giftAction;
      if (!action) {
        lastGiftAttempt = '';
        return;
      }

      const attemptKey = [action, this.dataset.giftVariantId, this.dataset.giftLineKey].join(':');
      if (attemptKey === lastGiftAttempt) return;
      lastGiftAttempt = attemptKey;

      let request;
      if (action === 'add') {
        request = postCart(theme.routes.cartAdd, {
          items: [{ id: Number(this.dataset.giftVariantId), quantity: 1, properties: { _gift: 'true' } }]
        });
      } else if (action === 'remove') {
        request = postCart(theme.routes.cartChange, { id: this.dataset.giftLineKey, quantity: 0 });
      } else if (action === 'limit') {
        request = postCart(theme.routes.cartChange, { id: this.dataset.giftLineKey, quantity: 1 });
      }
      if (!request) return;

      request
        .then(() => document.dispatchEvent(new CustomEvent('cart:build')))
        .catch((error) => console.error('[cart-rewards]', error));
    }

    scrollTrack(direction) {
      if (!this.track) return;
      this.track.scrollBy({ left: direction * this.track.clientWidth, behavior: 'smooth' });
    }

    addProduct(button) {
      button.setAttribute('aria-busy', 'true');
      postCart(theme.routes.cartAdd, { items: [{ id: Number(button.dataset.variantId), quantity: 1 }] })
        .then((data) => {
          if (data.status) {
            console.error('[cart-rewards]', data.description || data.message);
            return;
          }
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: { product: data.items ? data.items[0] : data, addToCartBtn: button }
          }));
        })
        .catch((error) => console.error('[cart-rewards]', error))
        .finally(() => button.removeAttribute('aria-busy'));
    }
  });
}
